(() => {
  let selectedCurrency =
    sessionStorage.getItem('minimumOrderBucksCurrency') || 'EUR';

  let updateTimer = null;

  function getBucksCurrency(detail) {
    if (typeof detail === 'string') {
      return detail.toUpperCase();
    }

    if (detail && typeof detail === 'object') {
      const currency =
        detail.currency ||
        detail.selectedCurrency ||
        detail.currencyCode ||
        detail.code;

      if (currency) {
        return String(currency).toUpperCase();
      }
    }

    return 'EUR';
  }

  function parseMoney(value) {
    let normalized = String(value || '')
      .replace(/[^\d,.\-]/g, '')
      .trim();

    if (!normalized) return 0;

    const lastComma = normalized.lastIndexOf(',');
    const lastDot = normalized.lastIndexOf('.');

    if (lastComma > lastDot) {
      normalized = normalized
        .replace(/\./g, '')
        .replace(',', '.');
    } else if (lastDot > lastComma) {
      normalized = normalized.replace(/,/g, '');
    } else {
      normalized = normalized.replace(',', '.');
    }

    return Number.parseFloat(normalized) || 0;
  }

  function formatMoney(amount, currency) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(Math.max(0, amount));
  }

  function setCheckoutDisabled(disabled) {
    document
      .querySelectorAll(
        'button[name="checkout"], input[name="checkout"]'
      )
      .forEach((button) => {
        button.disabled = disabled;
        button.setAttribute('aria-disabled', String(disabled));
      });

    document
      .querySelectorAll('[data-additional-checkout-buttons]')
      .forEach((container) => {
        container.hidden = disabled;
      });
  }

  function getVisibleCartTotal() {
    const elements = Array.from(
      document.querySelectorAll('[data-cart-subtotal]')
    );

    return (
      elements.find((element) => {
        return (
          element.getClientRects().length > 0 &&
          element.textContent.trim() !== ''
        );
      }) ||
      elements.at(-1) ||
      null
    );
  }

  function updateMinimumOrder() {
    document
      .querySelectorAll('[data-minimum-order]')
      .forEach((block) => {
        const country = String(
          block.dataset.country || ''
        ).toUpperCase();

        if (country === 'UA' || selectedCurrency === 'UAH') {
          block.hidden = true;
          setCheckoutDisabled(false);
          return;
        }

        const minimum =
          selectedCurrency === 'USD'
            ? Number(block.dataset.minimumUsd)
            : Number(block.dataset.minimumEur);

        const cartTotalElement = getVisibleCartTotal();

        const messageElement = block.querySelector(
          '[data-minimum-order-message]'
        );

        const progressElement = block.querySelector(
          '[data-minimum-order-progress]'
        );

        if (
          !cartTotalElement ||
          !messageElement ||
          !progressElement
        ) {
          return;
        }

        const cartTotal = parseMoney(
          cartTotalElement.textContent
        );

        const remaining = Math.max(
          0,
          minimum - cartTotal
        );

        const progress = Math.min(
          (cartTotal / minimum) * 100,
          100
        );

        block.hidden = false;
        progressElement.style.width = `${progress}%`;

        if (remaining > 0) {
          messageElement.innerHTML =
            `Minimum order amount is <strong>` +
            `${formatMoney(minimum, selectedCurrency)}</strong>. ` +
            `Add <strong>` +
            `${formatMoney(remaining, selectedCurrency)}</strong> ` +
            `more to checkout.`;

          setCheckoutDisabled(true);
        } else {
          messageElement.innerHTML =
            '<strong>Minimum order amount reached.</strong>';

          setCheckoutDisabled(false);
        }
      });
  }

function updateProductMinimumOrderNotice() {
  document
    .querySelectorAll('[data-product-minimum-order]')
    .forEach((block) => {
      const country = String(
        block.dataset.country || ''
      ).toUpperCase();

      const textElement = block.querySelector(
        '[data-product-minimum-order-text]'
      );

      if (!textElement) return;

      if (country === 'UA' || selectedCurrency === 'UAH') {
        block.hidden = true;
        return;
      }

      const minimum =
        selectedCurrency === 'USD' ? '$230' : '€200';

      textElement.innerHTML =
        'The minimum order amount ' +
        ` is <strong>${minimum}</strong>.`;

      block.hidden = false;
    });
}

function scheduleUpdate(delay = 300) {
  window.clearTimeout(updateTimer);

  updateTimer = window.setTimeout(() => {
    updateMinimumOrder();
    updateProductMinimumOrderNotice();
  }, delay);
}

  document.addEventListener(
    'BUCKS_SELECTED_CURRENCY',
    (event) => {
      selectedCurrency = getBucksCurrency(event.detail);

      sessionStorage.setItem(
        'minimumOrderBucksCurrency',
        selectedCurrency
      );

      scheduleUpdate(500);
    }
  );

  function initialize() {
    scheduleUpdate(700);

    const observer = new MutationObserver((mutations) => {
      const shouldUpdate = mutations.some((mutation) => {
        if (mutation.type === 'characterData') {
          return Boolean(
            mutation.parentElement?.closest(
              '[data-cart-subtotal]'
            )
          );
        }

        if (mutation.type === 'childList') {
          if (
            mutation.target.closest?.('[data-cart-subtotal]')
          ) {
            return true;
          }

          return Array.from(mutation.addedNodes).some((node) => {
            if (node.nodeType !== Node.ELEMENT_NODE) {
              return false;
            }

            return Boolean(
              node.matches?.(
                '[data-minimum-order], [data-cart-subtotal]'
              ) ||
              node.querySelector?.(
                '[data-minimum-order], [data-cart-subtotal]'
              )
            );
          });
        }

        return false;
      });

      if (shouldUpdate) {
        scheduleUpdate();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();